import { useState } from "react";
import XIcon from "src/components/ui/GlobalComponents/XIcon/XIcon";
import useUser from "src/hook/data/useUser";
import usePopUp from "src/hook/modal/usePopUp";
import { IconLocation } from "src/utils/URLUtils";
import BirthYearModal from "./BirthYearModal/BirthYearModal";
import styles from "./BirthYearSection.module.scss";

const BirthYearSection = () => {
    const { userInfo } = useUser();
    const [isVisible, setIsVisible] = useState(true);
    const { show } = usePopUp();

    const handleSelect = () => {
        show({
            children: <BirthYearModal />
        });
    }

    const handleClose = () => {
        setIsVisible(false);
    }


    if (userInfo?.BirthYear || !isVisible) {
        return null;
    }

    return (
        <div className={styles.birthYearSection}>
            <div className={styles.header}>
                <div className={styles.iconTitle}>
                    <img className="icon" src={IconLocation('info2')} alt="Info" />
                    <span className={styles.title}>WordUp</span>
                </div>
                <XIcon onClick={handleClose} />
            </div>
            <p className={styles.prompt}>Please enter your birth year</p>
            <button className={styles.selectBtn} onClick={handleSelect}>Select</button>
        </div>
    );
};

export default BirthYearSection;
